import * as LayoutActions from '../actions/layout.actions';
import {createReducer, on} from '@ngrx/store';

export interface State {
    isQuoteListOpen: boolean;
    isSubmittedQuoteListOpen: boolean;
    isSiteMenuOpen: boolean;
    isAdvancedSearchOpen: boolean;
    isQuoteViewSelectionOpen: boolean;
    isCreateNewQuoteMenuOpen: boolean;
}

const initialState: State = {
    isQuoteListOpen: false,
    isSubmittedQuoteListOpen: false,
    isSiteMenuOpen: false,
    isAdvancedSearchOpen: false,
    isQuoteViewSelectionOpen: false,
    isCreateNewQuoteMenuOpen: false
};

export const reducer = createReducer(
    initialState,
    on(LayoutActions.openQuoteList, state => ({ ...initialState, isQuoteListOpen: true, isQuoteViewSelectionOpen: true })),
    on(LayoutActions.openSubmittedQuoteList, state => ({ ...initialState, isQuoteListOpen: true, isSubmittedQuoteListOpen: true })),
    on(LayoutActions.closeQuoteList, LayoutActions.closeSiteMenu, state =>  ({...initialState, isQuoteViewSelectionOpen: true })),

    on(LayoutActions.closeAdvancedSearch, state => ({ ...state, isAdvancedSearchOpen: false })),
    on(LayoutActions.openAdvancedSearch, state => ({ ...initialState, isAdvancedSearchOpen: true })),
    on(LayoutActions.openSiteMenu, state => ({ ...initialState, isSiteMenuOpen: true})),

    on(LayoutActions.openQuoteViewSelection, state => ({...initialState, isQuoteViewSelectionOpen: true })),
    on(LayoutActions.closeQuoteViewSelection, state => ({...initialState })),

    on(LayoutActions.openCreateNewQuoteMenu, state => ({ ...initialState, isCreateNewQuoteMenuOpen: true, isQuoteViewSelectionOpen: true })),

    on(LayoutActions.closeCreateNewQuoteMenu, state => ({...initialState, isQuoteViewSelectionOpen: true })),
);

export const getIsSubmittedQuoteListOpen = (state: State) => state.isSubmittedQuoteListOpen;
export const getIsCreateNewQuoteMenuOpen = (state: State) => state.isCreateNewQuoteMenuOpen;
export const getIsAdvancedSearchOpen = (state: State) => state.isAdvancedSearchOpen;
export const getIsQuoteListOpen = (state: State) => state.isQuoteListOpen;
export const getIsSiteMenuOpen = (state: State) => state.isSiteMenuOpen;
